import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { useToast } from "../../components/ui/ToastContext";
import { jwtDecode } from 'jwt-decode';
import { AiOutlineDelete } from "react-icons/ai";
import { AiFillEdit } from "react-icons/ai";
import dayjs from "dayjs";
import { API_URL } from "../../config";

function DashboardCard22prod() {
  const { showToast } = useToast();
  const location = useLocation();
  const { item: initialData } = location.state || {};  // Obținem datele din location.state
  const [selectedEditRowData, setSelectedEditRowData] = useState(initialData);
  const [selecteddeleteuser, setSelecteddeleteuser] = useState(null);
  const [data, setData] = useState([]);
  const [defaultOption, setDefaultOption] = useState('');  // Default value should be role_id
  const [city, setCity] = useState([]);
  const [inst, setInst] = useState([]);
  const [open1, setOpen1] = useState(false);
  const [Nume_adres, setNume_adres] = useState("");
  const [filteredAdress, setFilteredAdress] = useState([]);
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showGrid, setShowGrid] = useState(true); // Stare pentru a controla ce să afișezi
  const [selecteduser, setSelecteduser] = useState(null);
  const getJwtFromCookies = () => {
    const cookies = document.cookie.split("; ");
    const tokenCookie = cookies.find(row => row.startsWith("accessToken="));
    return tokenCookie ? tokenCookie.split("=")[1] : null;
  };
  //const token = getJwtFromCookies();

  const token = localStorage.getItem('jwtToken');

  useEffect(() => {
    axios
      .get(`${API_URL}/api/productcategory`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setCity(response.data)
        // //////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  //   useEffect(() => {
  //     axios
  //       .get(`${API_URL}/api/product`, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //       })
  //       .then((response) => {

  //         const accessResponse = await axios.get(`${API_URL}/api/usersproducersacces`, {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             "Content-Type": "application/json",
  //           },
  //         });

  //         const userAccess = accessResponse.data
  //         .filter((i) => i.user_id === user?.userId)
  //         .map((i) => i.producer_or_producer_group_id);

  // //////console.log(userAccess)

  //         setInst(response.data)
  //         // //////////////////////////console.log(response.data)
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching user data:", error);

  //       });
  //   }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const productsResponse = await axios.get(`${API_URL}/api/product`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (user?.role === 'Admin') {
          setInst(productsResponse.data);
          return;
        }

        const accessResponse = await axios.get(`${API_URL}/api/usersproducersacces`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const userAccess = accessResponse.data
          .filter((i) => i.user_id === user?.userId)
          .map((i) => i.producer_or_producer_group_id);

        const val = productsResponse.data.filter((i) => userAccess.includes(i.producer_id))
        // //////console.log(val)

        setInst(val);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Consider setting an error state here
      }
    };

    fetchData();
  }, [user, selectedEditRowData]); // Added dependencies

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowGrid(false); // După 1 secundă, comutăm pe grid
    }, 1000);

    // Cleanup pentru timer
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);  // decoded is the correct variable here
        setUser(decoded); // Store decoded user data
        //////////////////////////////////console.log(user)
      } catch (error) {
        console.error('Error decoding the token:', error);
      }
    }
  }, []);

  const fetchManageData = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/physiciansinproduct`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const filteredPhysicians = response.data.filter(
        (item) => item.physician_id === selectedEditRowData?.physician_id
      );

      if (filteredPhysicians.length === 0) {
        setData([]);
        return;
      }

      if (user?.role === 'Admin') {
        setData(filteredPhysicians);
        return;
      }

      const accessResponse = await axios.get(`${API_URL}/api/usersproducersacces`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const userAccess = accessResponse.data
        .filter((i) => i.user_id === user?.userId)
        .map((i) => i.producer_or_producer_group_id);

      //////console.log(userAccess)

      const authorizedPhysicians = filteredPhysicians.filter(i =>
        userAccess.includes(i.producer_id)
      );

      //////console.log("Authorized physicians:", authorizedPhysicians);
      setData(authorizedPhysicians);

    } catch (error) {
      console.error("Error fetching manage data:", error);
      setData([]);
    }
  };

  useEffect(() => {
    fetchManageData();
  }, [selectedEditRowData, user]);

  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const currentItems = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    if (selecteddeleteuser) {
      deleteRowuser();
    }
  }, [selecteddeleteuser]);

  useEffect(() => {
    if (selecteduser) {
      //////////////////////////////console.log("Selected user to delete:", selecteduser);  // Aici poți verifica ce conține userul selectat
      handleOpenProd1();
    }
  }, [selecteduser]);

  const dropdownOptions = city.map((role) => ({
    value: role.product_category_id,
    label: role.description
  }));

  const _onSelect = (selectedOption) => {
    //////////////////////////////////////console.log(selectedOption);
    setDefaultOption(selectedOption);  // Set the selected option
  };

  const handleOpenRows = () => {
    setOpen(true); // Deschide dialogul
  };

  const handleOpenProd1 = () => {
    ////////////////////////console.log(selecteduser);
    setOpen1(true); // Deschide dialogul
    setNume_adres(selecteduser.product_name);
    setDefaultOption(selecteduser.product_category_id)
  };

  const handleButtonClick = async () => {
    setIsLoading(true);
    try {
      await handleSave(); // Simulate the save operation
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false); // Re-enable the button after operation completes
    }
  };

  const handleChangea = (e) => {
    const value = e.target.value;
    setNume_adres(value);

    if (value) {
      // Filter addresses based on user input
      const filtered = inst.filter((address) =>
        address.description.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredAdress(filtered);
    } else {
      setFilteredAdress([]);
    }
  };

  const handleSelectAddress = (address) => {
    setNume_adres(address.description);
    setFilteredAdress([]); // Close the suggestions once an address is selected
  };

  const deleteRowuser = async () => {
    ////////////////////////console.log(selecteddeleteuser)
    if (!selecteddeleteuser) return;
    try {
      await axios.put(
        `${API_URL}/api/deletephysiciansinproduct`, { physician_in_product_id: selecteddeleteuser.physician_in_product_id }
      );
      showToast({
        message: "Datele au fost sterse cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      });
      fetchManageData();
    } catch (error) {
      console.error("Error saving changes:", error);
      showToast({
        message: "Eroare la inserarea datelor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const handleSave = async () => {
    try {
      const filtered = inst.filter((address) =>
        address.description.toLowerCase() === Nume_adres.toLowerCase()
      );

      await axios.post(`${API_URL}/api/physiciansinproduct`, {
        physician_id: selectedEditRowData.physician_id,
        product_category_id: defaultOption, // Trimit toate ID-urile într-un array
        product_id: filtered[0].product_id
      });
      setNume_adres('');
      setDefaultOption('');
      setOpen(false);
      fetchManageData();
      showToast({
        message: "Datele au fost salvate cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      });
    } catch (error) {
      console.error(error);
      showToast({
        message: "Eroare la inserarea datelor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }

  };

  const handleEdit = async () => {
    // if (!Nume_prenume.trim()) {
    //   showToast({
    //     message: "Denumirea nu poate fi goală!",
    //     type: "error",
    //     icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
    //   });
    //   return;
    // }

    try {
      const filtered = inst.filter((address) =>
        address.description.toLowerCase() === Nume_adres.toLowerCase()
      );

      await axios.put(`${API_URL}/api/changephysiciansinproduct/${selecteduser.physician_in_product_id}`, {
        physician_id: selectedEditRowData.physician_id,
        product_category_id: defaultOption, // Trimit toate ID-urile într-un array
        product_id: filtered[0].product_id

      });
      fetchManageData();
      setOpen1(false);
      showToast({
        message: "Datele au fost salvate cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      });
    } catch (error) {
      console.error(error);
      showToast({
        message: "Eroare la inserarea datelor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  return (
    <div>
      {showGrid ? (
        <div className="flex flex-row gap-2">
          <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
          <div className="flex flex-col gap-2">
            <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
          </div>
        </div>
      ) : (
        <div className="col-span-full xl:col-span-8 bg-white dark:bg-gray-800 shadow-sm rounded-xl ">
          <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 flex justify-between items-center">
            <h2 className="font-semibold text-gray-800 dark:text-gray-100">Categorizarea pe produs</h2>
            {/* {user?.role === "Admin" && ( */}
            <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
              onClick={handleOpenRows}
            >
              <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
              </svg>
              <span className="//max-xs:sr-only">Adauga</span>

              <Transition appear show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={() => setOpen(false)}>
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                  </Transition.Child>

                  <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                      <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                      >
                        <Dialog.Panel className="w-full max-w-md transform  rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                          <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900  dark:text-gray-200">
                            Selectează categoria produs
                          </Dialog.Title>
                          <div className="relative mt-4">
                            <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800">Categoria produs</label>
                            <select
                              className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 `}  // Adaugă clasa pentru eroare
                              value={defaultOption}
                              onChange={(e) => _onSelect(e.target.value)}
                            >
                              <option value="" disabled>Alege categoria produs</option>
                              {dropdownOptions.map((option) => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                              ))}
                            </select>
                          </div>

                          <div className="relative mt-4">
                            <label className={`absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100 `}>
                              Produs
                            </label>
                            <input
                              className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100  `}
                              type="text"
                              name="produs"
                              placeholder={"Produs"}
                              value={Nume_adres}
                              onChange={handleChangea}
                            />

                            {/* Display filtered address suggestions */}
                            {filteredAdress && filteredAdress.length > 0 && (
                              <div className="absolute top-full left-0 w-full mt-1 bg-white border rounded-md shadow-md max-h-48 overflow-auto z-20">
                                {filteredAdress.map((address, index) => (
                                  <div
                                    key={index}
                                    className="p-2 cursor-pointer hover:bg-gray-200"
                                    onClick={() => handleSelectAddress(address)}
                                  >
                                    {address.description} {/* Afișează descrierea adresei */}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>

                          <div className="mt-4 flex justify-end gap-2">
                            <button
                              className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                              onClick={() => setOpen(false)}
                            >
                              Anulează
                            </button>

                            <button
                              className={`btn ${isLoading
                                ? "bg-gray-500 text-gray-300"
                                : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
                                }`}
                              onClick={handleButtonClick}
                              disabled={isLoading}
                            >
                              {isLoading ? (
                                <svg
                                  className="animate-spin fill-current shrink-0 xs:hidden"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="8"
                                    cy="8"
                                    r="7"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                  />
                                  <path
                                    className="opacity-75"
                                    d="M12 2a6 6 0 000 12V2z"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  className="fill-current shrink-0 xs:hidden"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                </svg>
                              )}
                              <span className="//max-xs:sr-only">
                                {isLoading ? "Saving..." : "Salveaza detaliile"}
                              </span>
                            </button>
                          </div>
                        </Dialog.Panel>
                      </Transition.Child>
                    </div>
                  </div>
                </Dialog>
              </Transition>
            </button>
            {/* )} */}

            <Transition appear show={open1} as={Fragment}>
              <Dialog as="div" className="relative z-10" onClose={() => setOpen1(false)}>
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                  <div className="flex min-h-full items-center justify-center p-4 text-center">
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0 scale-95"
                      enterTo="opacity-100 scale-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100 scale-100"
                      leaveTo="opacity-0 scale-95"
                    >
                      <Dialog.Panel className="w-full max-w-md transform rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                        <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900  dark:text-gray-200">
                          Editeaza Tipul de activitate
                        </Dialog.Title>
                        <div className="relative mt-4">
                          <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800">Categoria produs</label>
                          <select
                            className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 `}  // Adaugă clasa pentru eroare
                            value={defaultOption}
                            onChange={(e) => _onSelect(e.target.value)}
                          >
                            <option value="" disabled>Alege categoria produs</option>
                            {dropdownOptions.map((option) => (
                              <option key={option.value} value={option.value}>{option.label}</option>
                            ))}
                          </select>
                        </div>

                        <div className="relative mt-4">
                          <label className={`absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100 `}>
                            Produs
                          </label>
                          <input
                            className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100  `}
                            type="text"
                            name="produs"
                            placeholder={"Produs"}
                            value={Nume_adres}
                            onChange={handleChangea}
                          />

                          {/* Display filtered address suggestions */}
                          {filteredAdress && filteredAdress.length > 0 && (
                            <div className="absolute top-full left-0 w-full mt-1 bg-white border rounded-md shadow-md max-h-48 overflow-auto z-20">
                              {filteredAdress.map((address, index) => (
                                <div
                                  key={index}
                                  className="p-2 cursor-pointer hover:bg-gray-200"
                                  onClick={() => handleSelectAddress(address)}
                                >
                                  {address.description} {/* Afișează descrierea adresei */}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        <div className="mt-4 flex justify-end gap-2">
                          <button
                            className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                            onClick={() => setOpen1(false)}
                          >
                            Anulează
                          </button>
                          <button
                            className="px-4 py-2 rounded bg-gray-800 text-white hover:bg-gray-900 dark:bg-gray-200 dark:text-gray-700"
                            onClick={handleEdit}
                          >
                            Salvează
                          </button>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </Dialog>
            </Transition>
          </header>
          {data.length > 0 ? (

            <div className="p-3" >
              {/* Table */}
              <div className="overflow-x-auto">
                <table className="table-auto w-full dark:text-gray-300">
                  {/* Table header */}
                  <thead className="text-xs uppercase text-gray-400 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                    <tr>
                      <th className="p-2">
                        <div className="font-semibold text-left">Produs</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-left">Catgoria produs</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-center">Timpul crearii</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-center">Actiune</div>
                      </th>
                    </tr>
                  </thead>
                  {/* Table body */}
                  <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
                    {currentItems.map((customer, index) => {
                      return (
                        <tr
                          role="button"
                          key={customer.physician_in_product_id}
                          className={`${index % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"
                            } hover:bg-gray-200 dark:hover:bg-gray-600`}
                        >
                          <td className="p-2 whitespace-nowrap">
                            <div className="text-left">{customer.product_name
                            }</div>
                          </td>
                          <td className="p-2 whitespace-nowrap">
                            <div className="text-left">{customer.description}</div>
                          </td>
                          <td className="p-2 whitespace-nowrap">
                            <div className="text-center">{dayjs(customer.created_timestamp).add(1, 'day').format("DD-MM-YYYY")}</div>
                          </td>
                          <td>
                            <div className="font-semibold text-center"
                              style={{
                                fontWeight: "bold",
                                fontSize: "20px"
                              }}
                            >
                              <IconButton
                                onClick={() => setSelecteduser(customer)}
                                color="primary"
                                sx={{
                                  fontSize: "16px",
                                  borderRadius: "50%",
                                  "&:hover": {
                                    backgroundColor: "#a4adad",
                                  },
                                }}
                              >
                                < AiFillEdit className=" dark:text-gray-100" />
                              </IconButton>

                              <IconButton
                                onClick={() => setSelecteddeleteuser(customer)}
                                color="primary"
                                sx={{
                                  fontSize: "16px",
                                  borderRadius: "50%",
                                  "&:hover": {
                                    backgroundColor: "#a4adad",
                                  },
                                }}
                              >
                                <AiOutlineDelete className=" dark:text-gray-100" />
                              </IconButton>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {data.length > 5 && (
                <div className="flex justify-center mt-4">
                  <button
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-l-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                    disabled={currentPage === 1}
                  >
                    Prev
                  </button>

                  {currentPage > 3 && (
                    <>
                      <button
                        onClick={() => setCurrentPage(1)}
                        className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                      >
                        1
                      </button>
                      <span className="px-2">...</span>
                    </>
                  )}

                  {Array.from({ length: totalPages }, (_, index) => {
                    const page = index + 1;

                    if (
                      page === currentPage ||
                      // page === 1 ||
                      // page === totalPages ||
                      (page >= currentPage - 2 && page <= currentPage + 2)
                    ) {
                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-4 py-2 text-sm font-medium ${currentPage === page
                            ? "bg-gray-500 text-white"
                            : "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                            }`}
                        >
                          {page}
                        </button>
                      );
                    }
                    return null;
                  })}

                  {currentPage < totalPages - 2 && (
                    <>
                      <span className="px-2">...</span>
                      <button
                        onClick={() => setCurrentPage(totalPages)}
                        className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                      >
                        {totalPages}
                      </button>
                    </>
                  )}

                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                    className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-r-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          ) : (<h2 className="px-5 py-4 text-gray-600 dark:text-gray-400 ">Nicio categorizare per produse</h2>
          )}
        </div>
      )}
    </div>
  );
}

export default DashboardCard22prod;
